import { render, staticRenderFns } from "./ReplyFiles.vue?vue&type=template&id=f8aff458&scoped=true&"
import script from "./ReplyFiles.vue?vue&type=script&lang=js&"
export * from "./ReplyFiles.vue?vue&type=script&lang=js&"
import style0 from "./ReplyFiles.vue?vue&type=style&index=0&id=f8aff458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8aff458",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDialog,VFileInput,VRow})
